module.exports = __webpack_public_path__ + "img/DX-350.b495d8a1.jpg";